export function isPhone(phoneNumber) {
  return /^\+?1?[-.● ]?\(?([2-9][0-9]{2})\)?[-.● ]?([0-9]{3})[-.● ]?([0-9]{4})$/.test(phoneNumber)
}

// Format to 1 xxx xxx xxxx OR xxx xxx xxxx to display to user
export function formatPhone(phoneNumber) {
  let formattedPhoneNumber = phoneNumber.replace(/\D/g, '')

  if (/^\+?1/.test(phoneNumber)) {
    return formattedPhoneNumber.replace(/^(1)(\d{3})(\d{3})(\d{4})/, '+$1 $2 $3 $4')
  }

  if (formattedPhoneNumber[0] === '1') {
    formattedPhoneNumber = formattedPhoneNumber.slice(1)
  }

  return formattedPhoneNumber.replace(/^(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')
}

// Format xxx-xxx-xxxx to display to user
export function formatPhoneWithDash(phoneNumber) {
  let formattedPhoneNumber = phoneNumber.replace(/\D/g, '')

  if (formattedPhoneNumber[0] === '1') {
    formattedPhoneNumber = formattedPhoneNumber.slice(1)
  }
  return formattedPhoneNumber.replace(/^(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
}

// Normalize to +1xxxxxxxxxx to send to server
export function normalizePhone(phoneNumber) {
  let normalizedPhoneNumber = phoneNumber.replace(/\D/g, '')

  if (normalizedPhoneNumber[0] !== '1') {
    normalizedPhoneNumber = `1${normalizedPhoneNumber}`
  }

  return `+${normalizedPhoneNumber}`
}
